<template>
    <div class="header">
        <div class="logo-box">
          <img src="../assets/images/logo.png" alt="">
          <!-- <h3>{{$store.state.title}}</h3> -->
        </div>
        <a-menu
            theme="dark"
            mode="horizontal"
            v-model="firstMenuSelect" 
            :style="{ lineHeight: '64px' }"
            class="first-menu"
        >
            <a-menu-item v-for="(item,index) in firstMenuList" :key="index" @click="$router.push(item.url)">
                <i class="iconfont" :class="item.ico"></i>
                <p>{{item.name}}</p>
            </a-menu-item>
        </a-menu>
        <div class="user-operate" v-if="token!=''">
            <a-popover v-model="visible" title="待办" :overlayStyle="{'width':'22%'}">
              <div class="operate-box" style="cursor:pointer">
                
                <i class="iconfont icontitle_msg"></i>
                <a-badge :count="count">
                <span>消息</span>
                </a-badge>
              </div>
              <template slot="content">
                <a-list item-layout="horizontal" :data-source="data">
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta
                      :description="item.teacherName+'于'+item.applyDate+'发起申请，请审批！'"
                    >
                    <a slot="title"  @click="$router.push(item.url)">{{ item.workFlow }}</a>
                      <!-- <a-avatar
                        slot="avatar"
                        src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                      /> -->
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </template>
            </a-popover>
          <div class="operate-box">
            <i class="iconfont icontitle_person"></i>
            <span>{{$store.state.user.name}}</span>
          </div>
          <div class="operate-box">
            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <i class="iconfont icontitle_set"></i>
                <span>设置</span>
              </a>
              <a-menu slot="overlay">
                <a-menu-item @click="modifyPassword=true"><p>修改密码</p></a-menu-item>
                <a-menu-item @click="loginOut">退出</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <div class="user-operate">
          <router-link to="/login" v-if="token==''" class="operate-box" style="border:none">
            <i class="iconfont icondenglu"></i>
            <span>登录</span>
          </router-link>
        </div>
        <a-modal
          title="修改密码"
          :visible="modifyPassword"
          @ok="passwordOk"
          @cancel="passwordCancel"
        >
          <div class="input-box">
            <p>原密码：</p>
            <a-input-password placeholder="输入旧密码" v-model="oldPassword"/>
          </div>
          <div class="input-box">
            <p>新密码：</p>
            <a-input-password placeholder="输入新密码" v-model="newPassword"/>
          </div>
          <div class="input-box">
            <p>确认新密码：</p>
            <a-input-password placeholder="输入新密码" v-model="newPassword1"/>
          </div>
        </a-modal>
    </div>
</template>
<script>
import { Current,Logout,Edit } from '@/baseAPI/login'
import { getNav,getAllNav,todoList } from '@/baseAPI/nav'

export default {
    name:'Header',
    data() {
        return {
          firstMenuSelect:[],
          firstMenuList:[],
          token:'',
          modifyPassword:false,
          oldPassword:'',
          newPassword:'',
          newPassword1:'',
          userName:'',
          visible: false,
          data: [],
          count:0,
          stompClient:'',
          timer:'',
        };
    },
    components: {
    },
    watch:{
    },
    mounted () {
      this.token=this.$store.state.access_token;
      this.getUser()
      this.setRouter()
      this.todoList()
      // this.initWebSocket()
    },
    beforeDestroy: function () {
        // 页面离开时断开连接,清除定时器
        this.disconnect();
        clearInterval(this.timer);
    },
    updated(){
    },
    created(){
    },
    activated(){
      // if(this.$store.state.access_token!=''){
      //   this.token=this.$store.state.access_token;
      //   if(this.userName==''){
      //     this.getUser()
      //   }
      //   if(this.firstMenuList.length==0){
      //     this.setRouter()
      //   }
      // }
      // this.startNav()
    },
    watch:{
      $route(to,from){
        this.startUrl()
      }
    },
    methods:{
      initWebSocket() {
            this.connection();
            let that= this;
            // 断开重连机制,尝试发送消息,捕获异常发生时重连
            this.timer = setInterval(() => {
                try {
                    that.stompClient.send("test");
                } catch (err) {
                    console.log("断线了: " + err);
                    that.connection();
                }
            }, 5000);
        },  
        connection() {
            // 建立连接对象
            let socket = new this.SockJS('http://1.94.97.134/api-socket/websocket?access_token=7c8eae13-4254-4986-8f7a-80bf90c6067a');
            // 获取STOMP子协议的客户端对象
            this.stompClient = this.Stomp.over(socket);
            // 定义客户端的认证信息,按需求配置
            let headers = {
                // Authorization:''
            }
            // 向服务器发起websocket连接
            this.stompClient.connect(headers,() => {
                this.stompClient.subscribe('/topic/message', (msg) => { // 订阅服务端提供的某个topic
                    console.log('广播成功')
                    console.log('msg:'+msg);  // msg.body存放的是服务端发送给我们的信息
                },headers);
                // this.stompClient.send("/app/chat.addUser",
                //     headers,
                //     JSON.stringify({sender: '',chatType: 'JOIN'}),
                // )   //用户加入接口
            }, (err) => {
                // 连接发生错误时的处理函数
                console.log('失败')
                console.log(err);
            });
        },    //连接 后台
        disconnect() {
            if (this.stompClient) {
                this.stompClient.disconnect();
            }
        },  // 断开连接
      todoList(){
        todoList().then(res=>{
          this.data=res.data
          this.count=res.data.length
          this.data.forEach(item=>{
            if(item.type == '1'){
              item['url'] = '/admin/undergraduate/culture/exchange'
            }else if(item.type == '2'){
              item['url'] = '/admin/undergraduate/culture/syllabusAndBooks'
            }else if(item.type == '3'){
              item['url'] = '/admin/undergraduate/culture/parallelClass'
            }else if(item.type == '4'){
              item['url'] = '/admin/office/administration/meetingRooms'
            }else if(item.type == '5'){
              item['url'] = '/admin/office/seal'
            }
          })
        })
      },
      getUser(){
        if(this.token!='')
        {
          Current(this.token).then(res=>{
            this.$store.commit('set',{name:'user',val:res.data});
            this.userName=res.data.name;
          })
        }
      },
      setRouter(){
        if(this.token!='')
        {
          var firstArr=this.deepCopy(this.$router.options.routes[4].children)
          // this.firstMenuList=[{
          //   name:"首页",
          //   ico:'iconshouye',
          //   url:'/'
          // }];
          this.firstMenuList=[];
          for(let i=0;i<firstArr.length;i++)
          {
            firstArr[i].url=firstArr[i].path;
            this.firstMenuList.push(firstArr[i])
          }
          this.startUrl()
        }else{
          this.firstMenuSelect=[];
          this.firstMenuList=[];
        }
      },
      loginOut()
      {
        Logout(this.$store.state.access_token).then(()=>{
          this.token='';
          this.userName='';
          this.firstMenuSelect=[];
          this.firstMenuList=[];
          localStorage.setItem("access_token", '');
          localStorage.setItem("tokenTime", '');
          this.$store.commit('set',{name:'access_token',val:''});
          this.$notification.success({
            message: '成功',
            description: '成功退出',
            duration: 3
          })
          location.reload();
          // this.$router.push('/login')
        })
      },
      passwordOk()
      {
        if(this.newPassword1==this.newPassword)
        {
          var obj={
            newPassword:escape(this.newPassword),
            oldPassword:escape(this.oldPassword),
          }
          Edit(obj).then(res => {
            if(res.data.success)
            {
              this.modifyPassword=false;
              this.oldPassword='';
              this.newPassword='';
              this.newPassword1='';
              this.$notification['success']({
                  message: '修改成功',
              });
              this.loginOut();
            }
            else
            {
                this.$notification['error']({
                    message: res.data.errorMessage,
                });
            }
          })
        }
        else
        {
          this.$notification['error']({
              message: "两次密码不一致",
          });
        }
      },
      passwordCancel()
      {
        this.oldPassword='';
        this.newPassword='';
        this.newPassword1='';
        this.modifyPassword=false;
      },
      forRrouter(arr){
        var routerArr=[];
        for(let i=0;i<arr.length;i++){
          var obj={
              path: '/admin'+arr[i].url,
              meta:{
                  type:'login',    //是否需要登录权限
                  keepAlive: false, //是否缓存此组件
                  title:arr[i].name
              },
              children: [],
          };
          if(+arr[i].parentId!='0'){
            obj.component=() => import('@/components/'+arr[i].url+'.vue');
          }
          if(arr[i].children!=null){
            obj.children=this.forRrouter(arr[i].children)
          }
          routerArr.push(obj)
        }
        return routerArr
      },
      startUrl(){
        var pathArr=this.$router.options.routes;
        var path=this.$route.path;
        var obj=this.getPathObj(pathArr,path);
        if(typeof obj.children!='undefined'&&obj.children.length>0){
          this.$router.push(obj.children[0].path)
        }else{
          this.startNav()
        }
      },
      getPathObj(arr,url){
        for(let i=0;i<arr.length;i++){
          if(arr[i].path==url){
            return arr[i]
          }else{
            if(typeof arr[i].children!='undefined' && arr[i].children.length>0){
              var obj=this.getPathObj(arr[i].children,url);
              if(obj!=0){
                return obj
              }
            }
          }
        }
        return 0;
      },
      getPath(arr,url){
        for(let i=0;i<arr.length;i++)
        {
            if(arr[i].url==url||arr[i].path==url)
            {
              return i;
            }
        }
      },
      startNav(){
        var path=this.$route.path;
        for(var i=0;i<this.firstMenuList.length;i++){
          if(path.indexOf(this.firstMenuList[i].url)>-1){
            this.firstMenuSelect=[i];
            break;
          }
        }
        if(i==this.firstMenuList.length){
          this.firstMenuSelect=[];
        }
      }
    }

};
</script>

<style scoped>
.logo-box {
    height: 100%;
    display: inline-block;
}
.logo-box img{
    width: auto;
    height: 40px;
}
.logo-box h3{
    color: #fff;
    display: inline-block;
    margin-left: 1rem;
    font-size: 1.3rem;
}
.first-menu
{
    display: inline-block;
    vertical-align: top;
    background-color: transparent;
    margin-left: 2rem;
}
.first-menu .iconfont,.first-menu p
{
    display: inline-block;
    line-height: 63px;
}
.first-menu .iconfont
{
    margin-right: 0.5rem;
}
.user-operate
{
    float: right;
}
#app .user-operate .operate-box
{
  display: inline-block;
  vertical-align: middle;
  border-left: 2px solid rgba(255, 255, 255, 0.5);
  height: 1.6rem;
}
#app .user-operate .iconfont
{
    color: #fff;
    display: inline-block;
    vertical-align: top;
    font-size: 1.4rem;
    padding-left: 0.8rem;
    padding-right: 0.4rem;
    height: 1.6rem;
    line-height: 1.6rem;
    font-size: 1.2rem;
}
#app .user-operate .operate-box span
{
  display: inline-block;
  vertical-align: top;
  line-height: 1.6rem;
  margin-right: 0.8rem;
  color: #fff;
}

#app .user-operate .iconfont:nth-child(1)
{
    border: none;
}
#app .user-operate .ant-dropdown-link
{
  display: inline-block;
  vertical-align: top;
  height: 100%;
}
#app .user-operate .ant-dropdown-link .iconfont
{
  vertical-align: top;
}
.input-box
{
    margin-bottom: 1rem;
}
.input-box p
{
  display: inline-block;
  width: 20%;
  text-align: right;
}
.input-box .ant-input-affix-wrapper
{
    width: 80%;
}
.ant-list-item-meta {
    display: flex;
    flex: 1;
    align-items: flex-start;
    font-size: 1rem;
}
</style>
